<div class="custom-scrollbar">

    <!-- Back button -->
    <button class="sidenav-btn back-btn" (click)="goBack()"
            [ngClass]="{
              'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover
           }">
        <mat-icon>arrow_back</mat-icon>
        <span *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Back</span>
    </button>

    <ng-container *ngFor="let section of sideNavConfig">

        <div class="hr-bar">
            <div *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover"
                 class="fs-12 cont-head">
                {{ section.title }}
            </div>
            <div class="hori-line"></div>
        </div>

        <section class="sub-actions-container">

            <div *ngFor="let item of section.items"
                 class="sidenav-btn"
                 (click)="whatIsRoute(item.route)"
                 routerLinkActive="active"
                 [ngClass]="{
              'color-blue-set': checkIsRouteActive(item.route),
              'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover
           }">

                <div class="icon-area">
                    <lucide-angular *ngIf="item.icon" [img]="item.icon" [size]="22" />
                    <mat-icon *ngIf="item.matIcon" [svgIcon]="item.matIcon"></mat-icon>
                </div>

                <div class="side-nav-text"
                     *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">
                    {{ item.label }}
                </div>

            </div>

        </section>

    </ng-container>

</div>
